import { GET_DOMAINS, GET_DOMAINS_SUCCESS, GET_DOMAINS_FAIL, SHOW_DELETE_MODAL,  HIDE_DELETE_MODAL,
  DELETE_DOMAIN, DELETE_DOMAIN_SUCCESS, DELETE_DOMAIN_FAIL, CREATE_DOMAIN, CREATE_DOMAIN_SUCCESS, CREATE_DOMAIN_FAIL,
  UPDATE_DOMAIN, UPDATE_DOMAIN_SUCCESS, UPDATE_DOMAIN_FAIL, GET_DOMAIN, GET_DOMAIN_SUCCESS, GET_DOMAIN_FAIL} from "store/domains/actionTypes"

export const getDomains = (params) => ({
  type: GET_DOMAINS,
  payload: { params }
})

export const getDomainsSuccess = domains => ({
  type: GET_DOMAINS_SUCCESS,
  payload: domains,
})

export const getDomainsFail = error => ({
  type: GET_DOMAINS_FAIL,
  payload: error,
})

export const getDomain = (params) => ({
  type: GET_DOMAIN,
  payload: { params }
})

export const getDomainSuccess = (values) => ({
  type: GET_DOMAIN_SUCCESS,
  payload: values,
})

export const getDomainFail = error => ({
  type: GET_DOMAIN_FAIL,
  payload: error,
})

export const showDeleteModal = () => ({
  type: SHOW_DELETE_MODAL,
  payload: {}
});

export const hideDeleteModal = () => ({
  type: HIDE_DELETE_MODAL,
  payload: {}
})

export const deleteDomain = (params) => ({
  type: DELETE_DOMAIN,
  payload: {params}
})

export const deleteDomainSuccess = () => ({
  type: DELETE_DOMAIN_SUCCESS
})

export const deleteDomainFail = error => ({
  type: DELETE_DOMAIN_FAIL,
  payload: error
})

export const createDomain = (params) => ({
  type: CREATE_DOMAIN,
  payload: params
})

export const createDomainSuccess = () => ({
  type: CREATE_DOMAIN_SUCCESS
})

export const createDomainFail = error => ({
  type: CREATE_DOMAIN_FAIL,
  payload: error
})

export const updateDomain = (params) => ({
  type: UPDATE_DOMAIN,
  payload: params
})

export const updateDomainSuccess = () => ({
  type: UPDATE_DOMAIN_SUCCESS
})

export const updateDomainFail = error => ({
  type: UPDATE_DOMAIN_FAIL,
  payload: error
})